import { startCase } from 'lodash-es';
export const getOptionLabel = (option) => option.label || startCase(option.name);
